import axios from '../config/axios';
import {actions as A} from '../constants/actions';
import {checkNextStepForDuplicateFirstNameValue, isSecondStepNext} from "../utils/stepSubmit";
import {setRequestId} from "../utils/setRequestId";

export const getSpecificStep = (stepID) => {
  return (dispatch) => {
    dispatch({
      type: A.GET_SPECIFIC_STEP
    });
    setRequestId();

    return axios.get(`/regGeneral/getSpecificStep?regType=all&stepID=${stepID}`)
      .then((response) => {
        const {data} = response.data;
        const {
          nextStep,
          currentUserStepNumber,
          totalSteps,
          goBack,
          desktopCompletedStages,
          firstName,
          ...payload
        } = data;
        const regType = 'all';
        const formValues = checkNextStepForDuplicateFirstNameValue(nextStep, regType)
          ? {...payload, firstName}
          : payload;

        dispatch({
          type: A.GET_SPECIFIC_STEP_SUCCESS,
          payload: {
            nextStep,
            currentUserStepNumber,
            totalSteps,
            goBack,
            desktopCompletedStages
          }
        });
        dispatch({
          type: A.SET_STEP_PAYLOAD,
          payload: formValues
        });
        dispatch({
          type: A.SET_USER_NAME,
          payload: isSecondStepNext(nextStep, regType) ? '' : firstName
        });
      })
      .catch((err) => {
        return dispatch({
          type: A.GET_NEXT_STEP_FAILURE,
          payload: {errorMessage: err.message}
        })
      });
  }
};

